// src/components/popups/PauseDrawer.js
import React from 'react';
import './PauseDrawer.css';

function PauseDrawer({ onClose }) {
  return (
    <div className="drawer-overlay" onClick={onClose}>
      <div className="drawer" onClick={(e) => e.stopPropagation()}>
        <h3>⏸️ Order Paused</h3>
        <p>This order has been paused due to an ongoing dispute raised by one of the parties involved. The escrow countdown is temporarily on hold until the dispute is resolved.</p>
        <button onClick={onClose}>Got it</button>
      </div>
    </div>
  );
}

export default PauseDrawer;
